<div>
  <Navbar />
  <Sidebar />
  <div class="page-wrapper">
    <div class="hero-section w-100">
      <div class="border border-secondary rounded-4 p-2">

        <!-- Header -->
        <div class="mb-4">
          <h2 class="gradient-text fw-bold">Permission Management</h2>
          <p class="text-muted">Manage system permissions and access controls</p>
        </div>

        <!-- Statistics Cards -->
        <div class="row text-center mb-3">
          <div class="col-md-4 mb-3">
            <div class="card rounded-4 shadow-sm users-card" @click="filter_type = 'all'">
              <div class="card-body">
                <p class="card-text display-5">{{ permissions.length }}</p>
                <h5 class="card-title">Total Permissions</h5>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="card rounded-4 shadow-sm users-card" @click="filter_type = 'active'">
              <div class="card-body">
                <p class="card-text display-5">{{ active_permissions_count }}</p>
                <h5 class="card-title">Active Permissions</h5>
              </div>
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="card rounded-4 shadow-sm users-card" @click="filter_type = 'inactive'">
              <div class="card-body">
                <p class="card-text display-5">{{ inactive_permissions_count }}</p>
                <h5 class="card-title">Inactive Permissions</h5>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="d-flex mb-2">
          <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center"
            data-bs-toggle="modal" data-bs-target="#addPermissionModal">
            <i class="fas fa-plus plus-icon me-1"></i> Add Permission
          </button>
          <button class="upload-button btn-sm text-white box-shadow small d-flex align-items-center ms-2"
            @click="$router.back()">
            Back
          </button>
        </div>

        <!-- Permissions Table -->
        <div class="card table-card">
          <div class="card-body">
            <div class="table-responsive content-table">
              <table id="permissions_table" class="table text-xs table-striped" data-sort="true">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Permission Name</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody class="text-start text-xs">
                  <tr v-for="(permission, index) in filtered_permissions" :key="permission.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ permission.name }}</td>
                    <td>{{ permission.description }}</td>
                    <td>
                      <span :class="['badge', permission.is_active ? 'bg-success' : 'bg-danger']">
                        {{ permission.is_active ? 'Active' : 'Inactive' }}
                      </span>
                    </td>
                    <td>
                      <div class="d-flex gap-2 flex-nowrap">
                        <button class="btn btn-sm upload-button text-nowrap"
                          @click="open_manage_modal(permission)"
                          data-bs-toggle="modal"
                          data-bs-target="#updatePermissionModal">
                          Edit
                        </button>
                        <button class="btn btn-sm upload-button text-nowrap"
                          @click="open_manage_modal(permission)"
                          data-bs-toggle="modal"
                          data-bs-target="#managePermissionModal">
                          Assign Features
                        </button>
                        <button v-if="permission.is_active"
                          class="btn btn-sm btn-success text-nowrap action-btn-toggle"
                          @click="toggle_permission_status(permission)">
                          Deactivate
                        </button>
                        <button v-else
                          class="btn btn-sm btn-danger text-nowrap action-btn-toggle"
                          @click="toggle_permission_status(permission)">
                          Activate
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Add Permission Modal -->
        <div class="modal fade" id="addPermissionModal" tabindex="-1" aria-labelledby="addPermissionModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title gradient-text" id="addPermissionModalLabel">Create New Permission</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div class="modal-body">
                <form @submit.prevent="add_permission">
                  <div class="mb-3 text-start">
                    <label for="permission_name" class="ms-2">Permission Name</label>
                    <input v-model="permission_name"
                      type="text"
                      class="form-control"
                      id="permission_name"
                      placeholder="e.g., Staff Management Permission"
                      required>
                  </div>

                  <div class="mb-3 text-start">
                    <label for="permission_description" class="ms-2">Description</label>
                    <textarea v-model="permission_description"
                      class="form-control"
                      id="permission_description"
                      rows="3"
                      placeholder="Describe what this permission allows..."></textarea>
                  </div>

                  <div class="modal-footer">
                    <button type="submit" class="btn upload-button text-white" :disabled="permission_loading">
                      <span v-if="permission_loading" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                      {{ permission_loading ? 'Creating...' : 'Create Permission' }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Update Permission Modal -->
        <div class="modal fade" id="updatePermissionModal" tabindex="-1" aria-labelledby="updatePermissionModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title gradient-text" id="updatePermissionModalLabel">
                    Update: {{ name }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="mb-3 text-start">
                        <label for="manage_permission_name" class="ms-2">Permission Name</label>
                        <input v-model="name"
                        type="text"
                        class="form-control"
                        id="manage_permission_name">
                    </div>
                    <div class="mb-3 text-start">
                        <label for="manage_permission_description" class="ms-2">Description</label>
                        <input v-model="description"
                        type="text"
                        class="form-control"
                        id="manage_permission_description">
                    </div>
                    <div class="modal-footer">
                        <button @click="update_permission_basic_info"
                        class="btn btn-sm upload-button text-white"
                        :disabled="permission_loading">
                        <span v-if="permission_loading" class="spinner-border spinner-border-sm me-2"></span>
                         {{ permission_loading ? 'Updating...' : 'Update'}}
                        </button>
                    </div>
                </div>
            </div>
          </div>
        </div>

        <!-- Manage Permission Modal - FIXED TITLE -->
        <div class="modal fade" id="managePermissionModal" tabindex="-1" aria-labelledby="managePermissionModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">

              <!-- Modal Header -->
              <div class="modal-header border-bottom bg-light">
                <h5 class="modal-title gradient-text fw-bold" id="managePermissionModalLabel">
                  Assign Features to: <span class="text-primary">{{ name }}</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <!-- Modal Body -->
              <div class="modal-body modal-body-scroll">

                <!-- Loading State -->
                <div v-if="permission_loading" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-3 text-muted mb-0">Loading features...</p>
                </div>

                <!-- Features Content -->
                <div v-else>

                  <!-- Instructions -->
                  <div class="mb-3">
                    <p class="text-muted small mb-2">
                      <i class="fas fa-info-circle me-1"></i>
                      Select features and their CRUD actions to assign to <strong>{{ name }}</strong>
                    </p>
                  </div>

                  <!-- Main Features Accordion -->
                  <div class="accordion-custom">
                    <div v-for="main in features_hierarchy" :key="main.id" class="mb-3">

                      <!-- Main Feature Header -->
                      <div class="accordion-header-custom d-flex align-items-center justify-content-between"
                          :class="{ 'accordion-open': opened_accordion === main.id }">
                        <div class="d-flex align-items-center flex-grow-1" @click="toggle_accordion(main.id)">
                          <i class="fas fa-folder me-2"></i>
                          <span class="fw-semibold">{{ main.name }}</span>
                        </div>
                        <div class="d-flex align-items-center gap-3">
                          <div class="d-flex align-items-center">
                            <label :for="'main-toggle-' + main.id" class="me-2 mb-0 small text-muted">
                            </label>
                            <div class="form-check form-switch mb-0">
                              <input type="checkbox"
                                    :id="'main-toggle-' + main.id"
                                    :checked="is_main_feature_selected(main.id)"
                                    @click.stop="handle_main_feature_toggle($event, main.id)"
                                    class="form-check-input"
                                    role="switch">
                            </div>
                          </div>
                          <i class="fas fa-chevron-down accordion-icon-custom"
                            :class="{ 'rotated': opened_accordion === main.id }"
                            @click="toggle_accordion(main.id)"></i>
                        </div>
                      </div>

                      <!-- Sub Features Content -->
                      <transition name="accordion-slide">
                        <div v-show="opened_accordion === main.id" class="mt-2">
                          <div class="p-3 bg-light rounded">

                            <!-- Sub Features Grid -->
                            <div v-if="main.sub_features && main.sub_features.length > 0">
                              <div class="row g-3">

                                <!-- Sub Feature Card -->
                                <div v-for="sub in main.sub_features"
                                    :key="sub.id"
                                    class="col-md-6">
                                  <div class="card sub-feature-card h-100"
                                      :class="{ 'selected-card': is_sub_feature_selected(sub.id) }">
                                    <div class="card-body p-3">

                                      <!-- Sub Feature Header -->
                                      <div class="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
                                        <label :for="'sub-toggle-' + sub.id"
                                              class="fw-semibold mb-0 text-dark">
                                          <i class="fas fa-layer-group me-2 text-secondary"></i>
                                          {{ sub.name }}
                                        </label>

                                        <!-- Sub Feature Toggle -->
                                        <div class="form-check form-switch">
                                          <input type="checkbox"
                                                :id="'sub-toggle-' + sub.id"
                                                :checked="is_sub_feature_selected(sub.id)"
                                                @click.stop="handle_subfeature_toggle($event, main.id, sub.id)"
                                                class="form-check-input"
                                                role="switch">
                                        </div>
                                      </div>

                                      <!-- CRUD Actions List -->
                                      <div>
                                        <div v-if="sub.crud_actions && sub.crud_actions.length > 0">
                                          <div v-for="action in sub.crud_actions"
                                              :key="action.id"
                                              class="action-item d-flex align-items-center justify-content-between mb-2">

                                            <!-- Action Label -->
                                            <label :for="'action-toggle-' + action.id"
                                                  class="mb-0 small text-secondary d-flex align-items-center cursor-pointer">
                                              <i class="fas fa-circle me-2 action-bullet"></i>
                                              {{ action.name }}
                                            </label>

                                            <!-- Action Toggle -->
                                            <div class="form-check form-switch">
                                              <input type="checkbox"
                                                    :id="'action-toggle-' + action.id"
                                                    :checked="is_action_selected(action.id)"
                                                    @click.stop="handle_action_toggle($event, main.id, sub.id, action.id)"
                                                    class="form-check-input form-check-input-sm"
                                                    role="switch">
                                            </div>
                                          </div>
                                        </div>

                                        <!-- No Actions Available -->
                                        <div v-else class="text-muted fst-italic small text-center py-2">
                                          <i class="fas fa-info-circle me-1"></i>
                                          No actions available
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- No Sub Features -->
                            <div v-else class="text-center py-4">
                              <i class="fas fa-folder-open text-muted mb-2"></i>
                              <p class="text-muted mb-0">No sub features available</p>
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>

                  <!-- No Features Available -->
                  <div v-if="!features_hierarchy || features_hierarchy.length === 0"
                      class="alert alert-warning d-flex align-items-center">
                    <i class="fas fa-exclamation-triangle me-2"></i>
                    <span>No features available</span>
                  </div>
                </div>
              </div>

              <!-- Modal Footer -->
              <div class="modal-footer border-top bg-light">
                <button type="button"
                        @click="save_permission_assignments"
                        class="btn upload-button text-white"
                        :disabled="permission_loading || has_no_changes">
                  <span v-if="permission_loading" class="spinner-border spinner-border-sm me-2"></span>
                  {{ permission_loading ? 'Saving...' : 'Save Changes' }}
                </button>
              </div>
            </div>
          </div>
        </div>
    </div>
    </div>
   </div>
</div>